// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f5146357","453":"18c6981e","455":"c706c4ed","977":"c8ee9171"}[chunkId] + ".chunk.js";
};